<!-- 3766-时令列表专题    7665-markdown里人物菜品卡片   7737-markdown里带视频-推荐作品  -->
<template>
  <MCSKELETON v-if="isGteatChefbrowser" :is-show="gcshow" />
  <GCSKELETON v-else :is-show="gcshow" />
  <GCHEADER
    :status="content.status"
    :is-show="!isGteatChefbrowser"
    des="articlesview"
    :webapp-link="webappLink"
    :param="pathId"
  />
  <div v-show="!gcshow" class="figure_page">
    <template v-if="content.templete==2">
      <Template2 :content="content" @on-finish="loadImage" />
    </template>
    <template v-else-if="content.templete==3">
      <Template3 :content="content" @on-finish="loadImage" />
    </template>
    <template v-else-if="content.templete==1">
      <Template1 :content="content" :list="list" @on-finish="loadImage" />
    </template>
    <template v-else>
      <p class="no_data">暂无内容</p>
    </template>

    <div class="zanlist">
      <div class="zantitle"> {{ content.zan }} {{ $tm('articles.likes') }} {{ content.comment_sum }} {{ $tm('articles.comments') }}</div>
      <ul>
        <li v-for="(item,index) in content.praiselist" :key="index">
          <a :href="item.link"><img v-lazy="item.headpic"></a>
        </li>
      </ul>
    </div>

    <!-- 底部评论相关 -->
    <Comment :comment="comment" :comment-num="content.comment_num" />

    <GCMIDDE :is-show="!isGteatChefbrowser" :gc-id="id" />
    <div v-if="show_all && isGteatChefbrowser" class="pl_all">
      {{ $tm('articles.noData') }}
    </div>
  </div>
</template>

<script>
import { articles } from '@/api/api'
import utils from '@/utils/utils'
import { markdownVideoControl } from '@/utils/index'
import { Toast } from 'vant'

import GCHEADER from '@/components/gc-header'
import GCSKELETON from '@/components/gc-loading'
import MCSKELETON from '@/components/McSkeleton.vue'
import GCMIDDE from '@/components/gc-midde'
import Comment from './components/comment.vue'
import Template1 from './components/template1.vue'
import Template2 from './components/template2.vue'
import Template3 from './components/template3.vue'
// import Cookies from 'js-cookie'
import config from '@/config/config'
// import $ from 'jquery'
import '../../style/scss/articles.scss' // 专题富文本的样式
import '../../style/scss/articles/public.scss' // 专题详情的公共样式 如果翻车，直接把底部的 <style> 解开

export default {
  components: {
    GCMIDDE,
    GCSKELETON,
    MCSKELETON,
    GCHEADER,
    Comment,
    Template1,
    Template2,
    Template3
  },
  data() {
    return {
      gcshow: true,
      id: this.$route.query.id,
      content: {
        templete: 0,
        comment_num: 0,
        news_pic: '',
        pegs: [],
        contribution: [],
        recommends: [],
        users: {},
        detail: {},
        menu: [],
        praiselist: [],
        share: {},
        list: [],
        past_articles: [],
        relevant_recommend: []
      },
      comment: [],
      past_articlesShow: true,
      show_all: false,
      page: 1,
      artPage: 0, // data.list 数字最后一个的id
      list: [],
      downlink: '',
      androidshow: false,
      // new_lead_top_class_is: true,
      isGteatChefbrowser: utils.isGteatChefbrowser(),
      busy: false,
      routerLink: '',
      webappLink: '',
      pathId: '',
      isAchiveBottom: false // 滚动条是否到底部标志
      // 人物专题 temptete=2
      // isShowShare:true,//默认显示分享按钮 在名厨浏览器下显示 调原生分享功能
      // isShowFoodDetail:false,//是否显示推荐菜品详情
    }
  },
  created() {
    window.onscroll = () => {
      // 变量scrollTop是滚动条滚动时，距离顶部的距离
      var scrollTop =
        document.documentElement.scrollTop || document.body.scrollTop
      // 变量windowHeight是可视区的高度
      var windowHeight =
        document.documentElement.clientHeight || document.body.clientHeight
      // 变量scrollHeight是滚动条的总高度
      var scrollHeight =
        document.documentElement.scrollHeight || document.body.scrollHeight
      // 滚动条到底部的条件(距底部20px时触发加载)
      // console.log(scrollTop + windowHeight,scrollHeight)
      if (document.getElementById('ylist')) {
        var scrollHeights = document.getElementById('ylist').scrollHeight || document.body.scrollHeight
      }
      if (
        scrollTop + windowHeight >= scrollHeights - 100 &&
        !this.isAchiveBottom
      ) {
        this.isAchiveBottom = true
        this.getArticles()
      }
      if (
        scrollTop + windowHeight >= scrollHeight - 100 &&
        this.isAchiveBottom && !this.busy
      ) {
        this.busy = true
        if (this.isGteatChefbrowser) {
          this.getComment()
        }
      }
    }
    console.log('utils.isGteatChefbrowser()', utils.isGteatChefbrowser(), this.isGteatChefbrowser)

    this.getComment() // 获取评论
    this.getArticles() // 获取详情内容

    this.routerLink = decodeURIComponent('/articlesview')
    this.pathId = decodeURIComponent(this.$route.query.id)
    this.webappLink = `${config.webapplink}/articlesview?id=${this.$route.query.id}`
    console.log(this.routerLink)
  },
  mounted() {
    const _self = this
    if (this.isGteatChefbrowser) {
      this.loadPraise()
      // this.loadComment();
      /* eslint-disable */
      dsBridge.register('commentCallBack', function(comment_id, content) {
        utils.isLogin().then(res_isLogin => {
          res_isLogin = JSON.parse(res_isLogin)
          if (res_isLogin.data.is_login == 1) {
            utils.getAuth().then(res => {
              res = JSON.parse(res)
              if (res.success == 'yes') {
                const user_icon = res.data.auth_icon
                const members = typeof (res.data.members) === 'undefined' ? [] : res.data.members
                const data = {
                  id: comment_id,
                  addtime: new Date().getTime(),
                  duty: res.data.duty,
                  experience: res.data.experience,
                  head_pic: res.data.head_pic,
                  link: res.data.link,
                  nickname: res.data.nick_name,
                  ps: 0,
                  members: members,
                  reply: [],
                  role: res.data.role,
                  support_int: res.data.support_int,
                  uid: res.data.uid,
                  unit: res.data.unit,
                  user_icon: user_icon,
                  user_icon_list: [],
                  zan: '0',
                  longMore: '3',
                  comment: content
                }
                _self.comment.unshift(data)
                // _self.getNextComment()
              }
            })
          } else {
            utils.login().then(res => {
            })
          }
        })
		  })
	  }
	  this.$nextTick(function() {
      markdownVideoControl() // 控制markdown返回内容里视频的，必须
    })
  },
  methods: {
    loadImage: function(value) {
      this.gcshow = value
    },
    getArticles() {
      const artData = {
        id: this.id,
        list: this.artPage,
        preview: this.$route.query.preview == undefined ? 0 : 1,
        lang_id: this.$route.query.lang_id ? this.$route.query.lang_id : 1
      }

      articles.articles_view(artData).then(res => {
        this.isAchiveBottom = true
        if (res.data == undefined) { // 如果没数据2秒跳主页
          setTimeout(() => {
            location.href = '/'
          }, 2000)
          return Toast(res.message)
        }
        if (res.data.hasOwnProperty('new_lead_down')) { // 格式化富文本格式
          res.data.new_lead_down = res.data.new_lead_down.replace(/<img src=/g, '<img data-src=')
          res.data.new_lead_down = res.data.new_lead_down.replace(/width:3.84rem;height:3.84rem;position:absolute;left:50%;top:50%;margin:-1.92rem 0 0 -1.92rem;/g, 'width:1.38rem;height:1.38rem;position:absolute;left:50%;top:50%;margin:-.64rem 0 0 -.64rem;')
          res.data.new_lead_down = res.data.new_lead_down.replace(/background-size:3.84rem 3.84rem/g, 'background-size:1.38rem 1.38rem')
        }
        if (res.data.hasOwnProperty('new_lead_top')) { // 格式化富文本格式
          res.data.new_lead_top = res.data.new_lead_top.replace(/<img src=/g, '<img data-src=')
          res.data.new_lead_top = res.data.new_lead_top.replace(/width:3.84rem;height:3.84rem;position:absolute;left:50%;top:50%;margin:-1.92rem 0 0 -1.92rem;/g, 'width:1.38rem;height:1.38rem;position:absolute;left:50%;top:50%;margin:-.64rem 0 0 -.64rem;')
          res.data.new_lead_top = res.data.new_lead_top.replace(/background-size:3.84rem 3.84rem/g, 'background-size:1.38rem 1.38rem')
        }

        this.content = res.data // 下面判断中都给content赋值了
        window.document.title = res.data.news_title || '名厨MINGCHU' // 同上
        this.content.templete = this.content.templete || 1

        this.share(res.data) // 设置分享
        if(res.data.templete == 1) {
          if (this.artPage == 0) { // 记录的data.list最后一个item的id
				      this.list = res.data.list || [] // 没有则默认空数组
              if (this.list.length == 0) {
                this.artPage = null
              } else {
                this.artPage = 	this.list[this.list.length - 1].content_id
              }
              this.isAchiveBottom = false

				    } else {
              this.list = [...this.list, ...res.data.list] // 翻页数据合并
              this.isAchiveBottom = false
					    if (res.data.list.length == 0) {
                this.isAchiveBottom = true
					    } else {
                if (this.list.length == 0) {
                  this.artPage = null
                } else {
                  this.artPage = 	this.list[this.list.length - 1].content_id
                }
					    }
			    	}
        }
      })
    },

    getComment() { // 获取评论
      this.busy = true
      const data = []
      articles.comment(this.id, this.page).then(res => {
        if (res.data == '') {
          this.show_all = true
        } else {
          res.data.forEach(val => {
            const more = val.reply.length > 3
            val.longMore = 3
            val.more = more
            data.push(val)
          })
          this.page = this.page + 1
          this.comment.push.apply(this.comment, data)
          this.busy = false
        }
      })
    },
    getNextComment() { // 定义了没调用
      const data = []
      articles.comment(this.id, 1).then(res => {
        if (res.data == '') {
          this.show_all = true
        } else {
          res.data[0].longMore = 3
          this.comment.unshift(res.data[0])
        }
      })
    },
    share(_data) {
      const data = {
        share_title: this.content.share.share_title,
        share_desc: this.content.share.share_desc,
        share_link: this.content.share.share_link,
        share_img: this.content.share.share_img
      }
      utils.wechatShare(data)
    },
    shareBtn() { // 定义了没调用
      if (this.isGteatChefbrowser) {
        // 是否是名厨浏览器
        utils.showShare()
      } else {
        // this.share();
        console.log('微信环境')
      }
    },
    loadPraise() {
      utils.praise().then((uid, head_pic) => {
        utils.getAuth().then(res => {
          res = JSON.parse(res)
          if (res.success == 'yes') {
            const data = {
              uid: uid,
              link: res.data.link,
              headpic: res.data.head_pic
            }
            this.content.zan = Number(this.content.zan) + 1
            this.content.praiselist.unshift(data)
          }
        })
      })
    }
  }
}
</script>
